/**
 * VLSI EXPERT internal onboarding form catalogs.
 * Keep in sync with backend/src/domain/userCreationRequest/onboardingFormOptions.js
 */

export const ACCESS_NOT_REQUIRED = 'Access Not required';
export const PDK_EXCLUSIVE = 'NA';
export const TOOL_ACCESS_DURATION_MIN = 1;
export const TOOL_ACCESS_DURATION_MAX = 26;
export const TOOL_ACCESS_DURATION_DEFAULT = 26;
export const DEFAULT_PHONE_PREFIX = '+91';

export const TITLE_OPTIONS = [
  { id: 'Mr', label: 'Mr' },
  { id: 'Ms', label: 'Ms' },
  { id: 'Mrs', label: 'Mrs' },
  { id: 'Miss', label: 'Miss' },
  { id: 'Dr', label: 'Dr' },
  { id: 'Prof', label: 'Prof' },
];

export const BATCH_MODES = [
  { id: 'Online', label: 'Online' },
  { id: 'Offline', label: 'Offline' },
];

export const VNC_TOOLS = [
  ACCESS_NOT_REQUIRED,
  'Custom Compiler',
  'HSpice',
  'IC Validator (ICV)',
  'SpiceGlass',
  'StarRcxt',
  'VCS and Verdi',
  'Waveform Viewer',
];

export const PUTTY_TOOLS = [
  ACCESS_NOT_REQUIRED,
  'Design Compiler (DC)',
  'Fusion Compiler (FC)',
  'IC Compiler 2 (ICC2)',
  'IC Validator (ICV)',
  'Library Compiler (LC)',
  'PrimeTime (PT)',
  'StarRcxt',
];

export const SPECIAL_VNC_TOOLS = [
  ACCESS_NOT_REQUIRED,
  'Custom Compiler',
  'Design Compiler (DC)',
  'Fusion Compiler (FC)',
  'Hspice',
  'IC Compiler 2 (ICC2)',
  'IC Validator (ICV)',
  'Library Compiler (LC)',
  'PrimeTime (PT)',
  'SpiceGlass',
  'StarRcxt',
  'VCS and Verdi',
  'Waveform Viewer',
];

export const PDK_GRP_PERMISSIONS = ['pdk32', 'pdk40', 'pdk_cc', 'NA'];

export const LABS_ACCESS_OPTIONS = [
  'po',
  'ti',
  'ws',
  'ddc1',
  'ddc2',
  'dicc1',
  'dicc2',
  'dpt1',
  'dpt2',
  'dfc1',
  'dfc2',
  'dcc1',
  'dverilog',
  'dsv',
  'duvm1',
  'Other',
];

export const ONBOARDING_FORM_CATALOG = {
  titles: TITLE_OPTIONS,
  batchModes: BATCH_MODES,
  vncTools: VNC_TOOLS,
  puttyTools: PUTTY_TOOLS,
  specialVncTools: SPECIAL_VNC_TOOLS,
  pdkGrpPermissions: PDK_GRP_PERMISSIONS,
  labsAccess: LABS_ACCESS_OPTIONS,
  accessNotRequired: ACCESS_NOT_REQUIRED,
  pdkExclusive: PDK_EXCLUSIVE,
  toolAccessDurationMin: TOOL_ACCESS_DURATION_MIN,
  toolAccessDurationMax: TOOL_ACCESS_DURATION_MAX,
  toolAccessDurationDefault: TOOL_ACCESS_DURATION_DEFAULT,
  defaultPhonePrefix: DEFAULT_PHONE_PREFIX,
};

export function toggleExclusiveChoice(selected, value, exclusiveId) {
  const current = Array.isArray(selected) ? selected.filter(Boolean) : [];
  if (value === exclusiveId) {
    if (current.length === 1 && current[0] === exclusiveId) return [];
    return [exclusiveId];
  }
  const withoutExclusive = current.filter((item) => item !== exclusiveId);
  if (withoutExclusive.includes(value)) {
    return withoutExclusive.filter((item) => item !== value);
  }
  return [...withoutExclusive, value];
}

export function indianMobileDigits(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length >= 12) return digits.slice(-10);
  return digits.slice(0, 10);
}

const MONTH_LABELS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function formatToolStartDateDisplay(iso) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || '')) return iso || '';
  const [year, month, day] = iso.split('-');
  return `${day}-${MONTH_LABELS[Number(month) - 1]}-${year}`;
}

export function emptyOnboardingForm() {
  return {
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    courseCategoryId: '',
    modeOfBatch: '',
    totalFeesInr: '',
    needWelcomeEmail: '',
    needMyAcademyAccess: '',
    toolAccess: '',
    toolAccessDurationWeeks: String(TOOL_ACCESS_DURATION_DEFAULT),
    toolAccessStartDate: '',
    specialMachineVnc: '',
    vncTools: [ACCESS_NOT_REQUIRED],
    puttyTools: [ACCESS_NOT_REQUIRED],
    specialVncTools: [ACCESS_NOT_REQUIRED],
    pdkGrpPermissions: [],
    labsCopyHome: '',
    labsAccess: [],
  };
}
